<template>
  <div>
    <b-card-body class="border-bottom">
      <filter-list-component @filter="filterList"></filter-list-component>
    </b-card-body>
    <div v-if="loading" class="center">
      <b-spinner variant="primary" label="Lade Daten..."></b-spinner>
    </div>
    <b-table
      class="mb-0"
      striped
      :items="umsaetze"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc="true"
      :filter="filter"
      responsive
      hover
      v-else
    >
      <template #cell(title)="data">
        <div @click="$emit('tablerowClick', data.item)">
          {{ data.item.title.replaceAll("_", " ") }}
        </div>
      </template>
      <template #cell(umsatzIst)="data">
        <div
          @click="$emit('tablerowClick', data.item)"
          :class="
            data.item.umsatzIst >
            (getQuartalsZielName() === 'erstesQuartalZiel'
              ? data.item.umsatzZiele[0].erstesQuartalZiel
              : getQuartalsZielName() === 'zweitesQuartalZiel'
              ? data.item.umsatzZiele[0].zweitesQuartalZiel
              : getQuartalsZielName() === 'drittesQuartalZiel'
              ? data.item.umsatzZiele[0].drittesQuartalZiel
              : data.item.umsatzZiele[0].viertesQuartalZiel) /
              3
              ? 'text-success'
              : 'text-danger'
          "
        >
          {{ data.item.umsatzIst | formatCurrency }}
        </div>
      </template>
      <template #cell(umsatzSollMonat)="data">
        <div @click="$emit('tablerowClick', data.item)" class="italic">
          {{
            ((getQuartalsZielName() === "erstesQuartalZiel"
              ? data.item.umsatzZiele[0].erstesQuartalZiel
              : getQuartalsZielName() === "zweitesQuartalZiel"
              ? data.item.umsatzZiele[0].zweitesQuartalZiel
              : getQuartalsZielName() === "drittesQuartalZiel"
              ? data.item.umsatzZiele[0].drittesQuartalZiel
              : data.item.umsatzZiele[0].viertesQuartalZiel) /
              3)
              | formatCurrency
          }}
        </div>
      </template>
      <template #cell(umsatzIstQuartal)="data">
        <div
          @click="$emit('tablerowClick', data.item)"
          :class="
            data.item.umsatzIstQuartal >
            (getQuartalsZielName() === 'erstesQuartalZiel'
              ? data.item.umsatzZiele[0].erstesQuartalZiel
              : getQuartalsZielName() === 'zweitesQuartalZiel'
              ? data.item.umsatzZiele[0].zweitesQuartalZiel
              : getQuartalsZielName() === 'drittesQuartalZiel'
              ? data.item.umsatzZiele[0].drittesQuartalZiel
              : data.item.umsatzZiele[0].viertesQuartalZiel)
              ? 'text-success'
              : 'text-danger'
          "
        >
          {{ data.item.umsatzIstQuartal | formatCurrency }}
        </div>
      </template>
      <template #cell(umsatzSollQuartal)="data">
        <div @click="$emit('tablerowClick', data.item)" class="italic">
          {{
            getQuartalsZielName() === "erstesQuartalZiel"
              ? data.item.umsatzZiele[0].erstesQuartalZiel
              : getQuartalsZielName() === "zweitesQuartalZiel"
              ? data.item.umsatzZiele[0].zweitesQuartalZiel
              : getQuartalsZielName() === "drittesQuartalZiel"
              ? data.item.umsatzZiele[0].drittesQuartalZiel
              : data.item.umsatzZiele[0].viertesQuartalZiel | formatCurrency
          }}
        </div>
      </template>
      <template #cell(umsatzIstJahr)="data">
        <div
          @click="$emit('tablerowClick', data.item)"
          :class="
            data.item.umsatzIstJahr > data.item.umsatzZiele[0].jahresZiel
              ? 'text-success'
              : 'text-danger'
          "
        >
          {{ data.item.umsatzIstJahr | formatCurrency }}
        </div>
      </template>
      <template #cell(umsatzSollJahr)="data">
        <div @click="$emit('tablerowClick', data.item)" class="italic">
          {{ data.item.umsatzZiele[0].jahresZiel | formatCurrency }}
        </div>
      </template>
    </b-table>
  </div>
</template>
<script>
import FilterListComponent from "../FilterListComponent.vue";
import { functions, firestore } from "../../firebase";
import { httpsCallable } from "firebase/functions";
import moment from "moment-timezone";
import { doc, getDoc } from "firebase/firestore";

export default {
  name: "VizrtKundenumsaetzeTabelle",
  components: {
    FilterListComponent,
  },
  props: {
    selectedDate: String,
    vertriebler: String,
  },
  watch: {
    selectedDate(value) {
      this.selectedMonth = moment(value).format("YYYY-MM");
      this.fetchData();
    },
    vertriebler() {
      this.fetchData();
    },
  },
  methods: {
    summiereUmsaetze(umsaetze) {
      return umsaetze.reduce((acc, item) => acc + item.umsatzIst, 0);
    },
    summiereUmsaetzeQuartal(umsaetze) {
      return umsaetze.reduce((acc, item) => acc + item.umsatzIstQuartal, 0);
    },
    summiereUmsaetzeJahr(umsaetze) {
      return umsaetze.reduce((acc, item) => acc + item.umsatzIstJahr, 0);
    },
    tageImMonat() {
      const anzahlTageDesMonats = moment(this.selectedDate)
        .tz("Europe/Berlin")
        .daysInMonth();
      let tageDesMonats = [];
      let gesamtWerktageDesMonats = 0;

      for (let tag = 1; tag <= anzahlTageDesMonats; tag++) {
        const datum = moment(this.selectedDate)
          .tz("Europe/Berlin")
          .date(tag)
          .format("YYYY-MM-DD");
        const monat = moment(this.selectedDate)
          .tz("Europe/Berlin")
          .format("MM");

        let tagObject = {
          datum: datum,
          wochentag: moment(this.selectedDate)
            .tz("Europe/Berlin")
            .date(tag)
            .format("dddd"),
          feiertag: moment(datum).tz("Europe/Berlin").isHoliday("SH"),
          werktagDesMonats: 0,
          gesamtWerktageDesMonats: 0,
        };

        if (monat === "12" && (tag === 24 || tag === 31)) {
          tagObject.feiertag = "Interner Feiertag";
        }

        tageDesMonats.push(tagObject);
      }

      let werktagDesMonats = 1;

      tageDesMonats.forEach((tagObject) => {
        if (
          tagObject.wochentag !== "Saturday" &&
          tagObject.wochentag !== "Sunday" &&
          !tagObject.feiertag
        ) {
          tagObject.werktagDesMonats = werktagDesMonats++;
          gesamtWerktageDesMonats++;
        } else {
          tagObject.werktagDesMonats = werktagDesMonats - 1;
        }
      });

      tageDesMonats.forEach((tagObject) => {
        tagObject.gesamtWerktageDesMonats = gesamtWerktageDesMonats;
      });

      return tageDesMonats;
    },
    filterList(value) {
      this.filter = value;
    },
    async getUmsatzZiele(reseller) {
      const docRef = doc(firestore, "vizrtReseller", reseller);
      const docSnap = await getDoc(docRef);
      const ziele = [docSnap.data()].map((item) => {
        if (item) {
          return {
            jahresZiel: item[`${new Date().getFullYear()} Proposed Annual Revenue Target`],
            erstesQuartalZiel: item[`${new Date().getFullYear()} Proposed Q1 Target`],
            zweitesQuartalZiel: item[`${new Date().getFullYear()} Proposed Q2 Target`],
            drittesQuartalZiel: item[`${new Date().getFullYear()} Proposed Q3 Target`],
            viertesQuartalZiel: item[`${new Date().getFullYear()} Proposed Q4 Target`],
          };
        }
      });
      return ziele;
    },
    async getKunden(vertriebler) {
      const docRef = doc(
        firestore,
        "vizrtVertriebler",
        vertriebler.replaceAll(" ", "_")
      );
      const docSnap = await getDoc(docRef);
      return docSnap.data() ? docSnap.data().kunden : "";
    },
    getQuartalsZielName() {
      const date = new Date(this.selectedDate);
      if (
        date.getMonth() === 0 ||
        date.getMonth() === 1 ||
        date.getMonth() === 2
      ) {
        return "erstesQuartalZiel";
      } else if (
        date.getMonth() === 3 ||
        date.getMonth() === 4 ||
        date.getMonth() === 5
      ) {
        return "zweitesQuartalZiel";
      } else if (
        date.getMonth() === 6 ||
        date.getMonth() === 7 ||
        date.getMonth() === 8
      ) {
        return "drittesQuartalZiel";
      } else {
        return "viertesQuartalZiel";
      }
    },
    getQuartalStartDate() {
      const date = new Date(this.selectedDate);
      if (
        date.getMonth() === 0 ||
        date.getMonth() === 1 ||
        date.getMonth() === 2
      ) {
        return date.getFullYear() + "-" + "01" + "-01";
      } else if (
        date.getMonth() === 3 ||
        date.getMonth() === 4 ||
        date.getMonth() === 5
      ) {
        return date.getFullYear() + "-" + "04" + "-01";
      } else if (
        date.getMonth() === 6 ||
        date.getMonth() === 7 ||
        date.getMonth() === 8
      ) {
        return date.getFullYear() + "-" + "07" + "-01";
      } else {
        return date.getFullYear() + "-" + "10" + "-01";
      }
    },
    createQuery(lieferantennummern, kunden) {
      const lieferantennummernString =
        "'" + lieferantennummern.join("','") + "'";

      const queryArray = kunden.map((kunde) => {
        const kundennummernString = "'" + kunde.kundennummern.join("','") + "'";

        return `
          SELECT '${kunde.name}' AS title, SUM(\`Wert\`) As umsatz
          FROM \`clgmbh-trademaster.trademasterData2025.table*\`
          WHERE \`Datum\` BETWEEN '${this.selectedMonth}-01' AND '${this.selectedDate}'
          AND \`Lieferantennummer\` IN (${lieferantennummernString})
          AND \`Kundennummer\` IN (${kundennummernString})
          AND \`Warengruppe\` NOT IN ('Technik RMA', 'CLEK_GSAnforderung', 'SONDERARTIKEL', 'Sonderartikel')
          AND \`Artikelnummer\` != 'B-1000-Acronis'
        `;
      });

      return queryArray.join(" UNION ALL ");
    },
    createQueryQuartal(lieferantennummern, kunden) {
      const quartalStartDate = this.getQuartalStartDate();
      const lieferantennummernString =
        "'" + lieferantennummern.join("','") + "'";
      const queryArray = kunden.map((kunde) => {
        const kundennummernString = "'" + kunde.kundennummern.join("','") + "'";

        return `
          SELECT '${kunde.name}' AS title, SUM(\`Wert\`) As umsatz
          FROM \`clgmbh-trademaster.trademasterData2025.table*\`
          WHERE \`Datum\` BETWEEN '${quartalStartDate}' AND '${this.selectedDate}'
          AND \`Lieferantennummer\` IN (${lieferantennummernString})
          AND \`Kundennummer\` IN (${kundennummernString})
          AND \`Warengruppe\` NOT IN ('Technik RMA', 'CLEK_GSAnforderung', 'SONDERARTIKEL', 'Sonderartikel')
          AND \`Artikelnummer\` != 'B-1000-Acronis'
        `;
      });

      return queryArray.join(" UNION ALL ");
    },
    createQueryJahr(lieferantennummern, kunden) {
      const now = new Date();
      const firstDayOfYear = now.getFullYear() + "-01-01";
      const lieferantennummernString =
        "'" + lieferantennummern.join("','") + "'";
      const queryArray = kunden.map((kunde) => {
        const kundennummernString = "'" + kunde.kundennummern.join("','") + "'";
        return `
          SELECT '${kunde.name}' AS title, SUM(\`Wert\`) As umsatz
          FROM \`clgmbh-trademaster.trademasterData2025.table*\`
          WHERE \`Datum\` BETWEEN '${firstDayOfYear}' AND '${this.selectedDate}'
          AND \`Lieferantennummer\` IN (${lieferantennummernString})
          AND \`Kundennummer\` IN (${kundennummernString})
          AND \`Warengruppe\` NOT IN ('Technik RMA', 'CLEK_GSAnforderung', 'SONDERARTIKEL', 'Sonderartikel')
          AND \`Artikelnummer\` != 'B-1000-Acronis'
        `;
      });

      return queryArray.join(" UNION ALL ");
    },
    async fetchData() {
      try {
        this.loading = true;
        const [lieferantennummern, kunden] = await Promise.all([
          ["25000504"],
          this.getKunden(this.vertriebler),
        ]);
        if (kunden.length > 0) {
          const query = this.createQuery(lieferantennummern, kunden);
          const queryQuartal = this.createQueryQuartal(
            lieferantennummern,
            kunden
          );
          const queryJahr = this.createQueryJahr(lieferantennummern, kunden);
          const queryBigQuery = httpsCallable(functions, "queryBigQuery");
          const result = await queryBigQuery({ query: query });
          const resultQuartal = await queryBigQuery({ query: queryQuartal });
          const resultJahr = await queryBigQuery({ query: queryJahr });

          const umsaetze = JSON.parse(result.data.data);
          const umsaetzeQuartal = JSON.parse(resultQuartal.data.data);
          const umsaetzeJahr = JSON.parse(resultJahr.data.data);

          const umsatzZiele = [];

          console.log(umsaetzeJahr);

          for await (const item of umsaetze) {
            const umsatzziele = await this.getUmsatzZiele(item.title);
            umsatzZiele.push({
              reseller: item.title,
              ziele: [...umsatzziele],
            });
          }

          let final = [];
          if (umsaetze.length > 0) {
            final = umsaetze.map((umsatz) => {
              const passenderKunde = kunden.find(
                (kunde) => kunde.name === umsatz.title
              );
              const passenderUmsatzQuartal = umsaetzeQuartal.find(
                (umsatzQuartal) => umsatzQuartal.title === umsatz.title
              );
              const passenderUmsatzJahr = umsaetzeJahr.find(
                (umsatzJahr) => umsatzJahr.title === umsatz.title
              );
              umsatz.umsatzziele = umsatzZiele.filter(
                (item) => item.reseller === umsatz.title
              )[0].ziele;
              umsatz.kundennummern = passenderKunde.kundennummern
                ? passenderKunde.kundennummern
                : null;
              umsatz.lieferantennummern = lieferantennummern
                ? lieferantennummern
                : null;
              umsatz.umsatz =
                umsatz.umsatz === null ? 0 : Number(umsatz.umsatz);
              umsatz.umsatzQuartal =
                passenderUmsatzQuartal.umsatz === null
                  ? 0
                  : Number(passenderUmsatzQuartal.umsatz);
              umsatz.umsatzJahr =
                passenderUmsatzJahr.umsatz === null
                  ? 0
                  : Number(passenderUmsatzJahr.umsatz);

              return umsatz;
            });

            this.umsaetze = final.map((element) => {
              return {
                title: element.title,
                umsatzIst: element.umsatz,
                umsatzIstQuartal: element.umsatzQuartal,
                umsatzIstJahr: element.umsatzJahr,
                extraData: {
                  kundennummern: element.kundennummern,
                  lieferantennummern: element.lieferantennummern,
                },
                umsatzZiele: element.umsatzziele,
              };
            });
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchData();
  },
  data() {
    return {
      loading: false,
      filter: null,
      umsaetze: [],
      sortBy: "umsatzIst",
      selectedMonth: moment().format("YYYY-MM"),
      fields: [
        {
          key: "title",
          label: this.$t("vizrt.kunde"),
        },
        {
          key: "umsatzIst",
          label: this.$t("vizrt.umsatzIst"),
          sortable: true,
        },
        {
          key: "umsatzSollMonat",
          label: this.$t("vizrt.umsatzSollMonat"),
        },
        {
          key: "umsatzIstQuartal",
          label: this.$t("vizrt.umsatzQuartal"),
          sortable: true,
        },
        {
          key: "umsatzSollQuartal",
          label: this.$t("vizrt.umsatzSollQuartal"),
        },
        {
          key: "umsatzIstJahr",
          label: this.$t("vizrt.umsatzJahr"),
          sortable: true,
        },
        {
          key: "umsatzSollJahr",
          label: this.$t("vizrt.umsatzSollJahr"),
        },
      ],
    };
  },
};
</script>
<style scoped>
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
th {
  white-space: nowrap;
}
th.sortierbar {
  cursor: pointer;
}
.italic {
  font-style: italic;
}
</style>
